export const messageLengthMin = 0;
export const messageLengthMax = 2046;

export const countUsersMin = 3;
export const countUsersMax = 100;

export const activityTypes = {
    registrationPoints: {
        name: 'Регистрация',
    },
    messagePoints: {
        name: 'Сообщение в чат',
    },
    messageReplyPoints: {
        name: 'Ответ на сообщение',
    },
    questionPoints: {
        name: 'Общий вопрос',
    },
    speakerQuestionPoints: {
        name: 'Вопрос спикеру в процессе трансляции',
    },
    questionLikePoints: {
        name: 'Лайк вопроса',
    },
    pollAnswerPoints: {
        name: 'Участие в опросе',
    },
    quizPassedPoints: {
        name: 'Прохождение квиза',
    },
    quizQuestionCorrectAnswerPoints: {
        name: 'Правильный ответ на вопрос в квизе',
    },
}
